//Importamos las conexiones necesarias
import conexiones from "../js/api/conexion.js"

//Importamos las conexiones de las API's
import comun from "../js/api/comun/comunapi.js"
import login from "../js/api/login/loginapi.js"
import pj from "../js/api/PJ/pjapi.js"
import cuentas from "../js/api/Cuentas/cuentasapi.js"
import firmaelectronica from "../js/api/firmaelectronica/firmaelectronicaapi.js"
import diashabiles from "../js/api/diashabiles/diashabilesapi.js"
import temiscivil from "../js/api/temiscivil/temiscivilapi.js"
import forseti from "../js/api/forseti/forsetiapi.js"
import siap from "../js/api/siap/siapapi.js"
import siseva from "../js/api/siseva/sisevaapi.js"
import archivojudicial from "../js/api/ArchivoJudicial/archivojudicialapi.js"
import sicpo from "../js/api/SICPO/sicpoapi.js"
import sinoj from "../js/api/SINOJ/sinojapi.js"
import EQUITAS from "../js/api/EQUITAS/equitasapi.js"
import PaginaOficial from "../js/api/PaginaOficial/paginaoficialapi.js"
import SICUS from "../js/api/SICUS/sicusapi.js"
import siccij from "../js/api/SICCIJ/siccijapi.js"
import sicsen from "../js/api/SICSEN/SICSENapi.js"
import sipsic from "../js/api/SIPSIC/sipsicapi.js"
import siqa from "../js/api/SIQA/siqaapi.js"
import sifa from "../js/api/SIFA/sifaapi.js"
import GestionAudiencias from "./api/AudienciasTemporal/AudienciasTemporalAPI.js"
import sicpe from "../js/api/SICPE/sicpeapi.js"
import sivac from "../js/api/SIVAC/SIVACapi.js"

//Creamos la variable de api y asignamos datos
const api = {};

//api.conexion = conexiones.Local;
//api.conexion = conexiones.Desarrollo_AmericaLeon;
//api.conexion = conexiones.Desarrollo_CitlalliJara;
//api.conexion = conexiones.Desarrollo_EduardoQuiroz;
//api.conexion = conexiones.Desarrollo_FranciscoOrduno;
//api.conexion = conexiones.Desarrollo_FabianCano;
//api.conexion = conexiones.Desarrollo_ManuelGonzalez;
//api.conexion = conexiones.Desarrollo_CristinaGallegos;
//api.conexion = conexiones.Desarrollo_FlavioGonzalez;
//api.conexion = conexiones.Desarrollo_CesarGuerrero;
//api.conexion = conexiones.Desarrollo_ManuelEsquivel;
//api.conexion = conexiones.Desarrollo_FlorRuiz;
//api.conexion = conexiones.Desarrollo;
api.conexion = conexiones.Produccion;
//api.conexion = conexiones.ProduccionForsetiPruebas

api.Comun = comun;
api.Login = login;
api.PJ = pj;
api.Cuentas = cuentas;
api.DiasHabiles = diashabiles;
api.FirmaElectronica = firmaelectronica;
api.TemisCivil = temiscivil;
api.Forseti = forseti;
api.SIAP = siap;
api.SISEVA = siseva;
api.ArchivoJudicial = archivojudicial;
api.SINOJ = sinoj;
api.EQUITAS = EQUITAS;
api.SICPO = sicpo;
api.PaginaOficial = PaginaOficial;
api.SICUS = SICUS;
api.SICCIJ = siccij;
api.SICSEN = sicsen;
api.SIPSIC = sipsic;
api.SIQA = siqa;
api.SIFA = sifa;
api.GestionAudiencias = GestionAudiencias;
api.SICPE = sicpe;
api.SIVAC = sivac;

//Exportamos los datos de api
export default api;



//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = null
// module chunks = 